<template>
    <div class="page-wrapper">
        <h3 class="tit">永东创艺园</h3>
        <div class="top-btns">
            <el-button class="r-btn" type="primary" icon="el-icon-edit" size="medium" @click="editHandle" :disabled="!uneditable">编辑表单</el-button>
            <br>
            <el-button class="r-btn" type="success" icon="el-icon-link" size="medium" @click="linkToDataV">查看大屏</el-button>
            <br>
            <el-button class="r-btn" type="warning" icon="el-icon-circle-check" size="medium" @click="takeEffectAtOnce">立即生效</el-button>
            <br>
            <el-button class="r-btn" type="info" icon="el-icon-top" size="medium" @click="toPageTop">回到顶部</el-button>
        </div>
        
        <div class="datav-form-wrapper">
            <el-form class="c-form" :model="editForm" ref="editForm" label-position="top">
                <el-form-item class="c-form-item" label="设计师品牌订单金额">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-headquarters/015.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-headquarters/015.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        设计师名称可输入，销售额(元)为最小值和最大值之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.designerOrderAmount" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerOrderAmount.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入设计师名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">设计师</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerOrderAmount.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min=switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.designerOrderAmount, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerOrderAmount.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max=switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.designerOrderAmount, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.designerOrderAmount.length === 1}" 
                                    :title="editForm.designerOrderAmount.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('designerOrderAmount', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('designerOrderAmount', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>
                <el-form-item class="c-form-item" label="本季服装设计关键词">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-yongdong/002.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-yongdong/002.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       关键词相关配置， 权重和展示类别均为整数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.designKeyWords" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designKeyWords.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入关键词', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">关键词</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designKeyWords.' + index + '.weight'"
                                    :rules="[
                                        { required: true, message: '请输入权重（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.weight" :disabled="uneditable"
                                        @blur="item.weight=switchToInt(item.weight, 'unsigned')"
                                    >
                                        <template slot="prepend">权重</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designKeyWords.' + index + '.type'"
                                    :rules="[
                                        { required: true, message: '请输入展示类别（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.type" :disabled="uneditable"
                                        @blur="item.type=switchToInt(item.type, 'unsigned')"
                                    >
                                        <template slot="prepend">展示类别</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.designKeyWords.length === 1}" 
                                    :title="editForm.designKeyWords.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('designKeyWords', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('designKeyWords', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="品牌出款排行">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-yongdong/003.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-yongdong/003.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       改为当月品牌出款,按永东最新企业清单的数据更新企业名称，出款量（整数）
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.brandOutputRank" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'brandOutputRank.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入企业名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">企业名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'brandOutputRank.' + index + '.radix'"
                                    :rules="[
                                        { required: true, message: '请输入出款量（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.radix" :disabled="uneditable"
                                        @blur="item.radix=switchToInt(item.radix, 'unsigned')"
                                    >
                                        <template slot="prepend">出款量</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.brandOutputRank.length === 1}" 
                                    :title="editForm.brandOutputRank.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('brandOutputRank', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('brandOutputRank', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="销售渠道占比">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-yongdong/004.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-yongdong/004.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       各渠道的占比（%） = 最小值（整数）和最大值（整数）之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.salesChannelPercent" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'salesChannelPercent.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入渠道名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">渠道名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'salesChannelPercent.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min=switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.salesChannelPercent, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'salesChannelPercent.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                         @blur="item.max=switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.salesChannelPercent, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.salesChannelPercent.length === 1}" 
                                    :title="editForm.salesChannelPercent.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('salesChannelPercent', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('salesChannelPercent', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="入驻设计师数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-yongdong/005.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-yongdong/005.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        入驻设计师数 = 固定基数基础上，每月递增最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数"
                        prop="designerJoinNumber.radix"
                        :rules="[
                            { required: true, message: '请输入固定基数（整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.designerJoinNumber.radix=switchToInt(editForm.designerJoinNumber.radix)"
                            class="w"
                            v-model="editForm.designerJoinNumber.radix"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="c-form-item-inner" label="每月递增范围" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="designerJoinNumber.min"
                                :rules="[
                                    { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.designerJoinNumber.min=switchToInt(editForm.designerJoinNumber.min, 'unsigned');switchObjMaxAndMin(editForm.designerJoinNumber)"
                                    v-model="editForm.designerJoinNumber.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="designerJoinNumber.max"
                                :rules="[
                                    { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.designerJoinNumber.max=switchToInt(editForm.designerJoinNumber.max, 'unsigned');switchObjMaxAndMin(editForm.designerJoinNumber)"
                                    v-model="editForm.designerJoinNumber.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="对接版房">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-yongdong/006.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-yongdong/006.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        改为对接打版订单，对接打版订单数 = 固定基数基础上，每日递增最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数"
                        prop="connectSampleRoom.radix"
                        :rules="[
                            { required: true, message: '请输入固定基数（整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.connectSampleRoom.radix=switchToInt(editForm.connectSampleRoom.radix)"
                            class="w"
                            v-model="editForm.connectSampleRoom.radix"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="c-form-item-inner" label="每日递增范围" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="connectSampleRoom.min"
                                :rules="[
                                    { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.connectSampleRoom.min=switchToInt(editForm.connectSampleRoom.min, 'unsigned');switchObjMaxAndMin(editForm.connectSampleRoom)"
                                    v-model="editForm.connectSampleRoom.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="connectSampleRoom.max"
                                :rules="[
                                    { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.connectSampleRoom.max=switchToInt(editForm.connectSampleRoom.max, 'unsigned');switchObjMaxAndMin(editForm.connectSampleRoom)"
                                    v-model="editForm.connectSampleRoom.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="投产量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-yongdong/007.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-yongdong/007.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        投产量 = 固定基数基础上，每月递增最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数"
                        prop="productionAmount.radix"
                        :rules="[
                            { required: true, message: '请输入固定基数（整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.productionAmount.radix=switchToInt(editForm.productionAmount.radix)"
                            class="w"
                            v-model="editForm.productionAmount.radix"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="c-form-item-inner" label="每月递增范围" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="productionAmount.min"
                                :rules="[
                                    { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                   @blur="editForm.productionAmount.min=switchToInt(editForm.productionAmount.min, 'unsigned');switchObjMaxAndMin(editForm.productionAmount)"
                                    v-model="editForm.productionAmount.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="productionAmount.max"
                                :rules="[
                                    { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.productionAmount.max=switchToInt(editForm.productionAmount.max, 'unsigned');switchObjMaxAndMin(editForm.productionAmount)"
                                    v-model="editForm.productionAmount.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="出款总金额">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-yongdong/008.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-yongdong/008.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        出款总金额 = 固定基数基础上，每月递增最小值和最大值之间的随机数
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数"
                        prop="outputTotalAmount.radix"
                        :rules="[
                            { required: true, message: '请输入固定基数（整数）', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            @blur="editForm.outputTotalAmount.radix=switchToInt(editForm.outputTotalAmount.radix);"
                            class="w"
                            v-model="editForm.outputTotalAmount.radix"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="c-form-item-inner" label="每月递增范围" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="outputTotalAmount.min"
                                :rules="[
                                    { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.outputTotalAmount.min=switchToInt(editForm.outputTotalAmount.min, 'unsigned');switchObjMaxAndMin(editForm.outputTotalAmount)"
                                    v-model="editForm.outputTotalAmount.min"
                                    placeholder="请输入最小值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="outputTotalAmount.max"
                                :rules="[
                                    { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.outputTotalAmount.max=switchToInt(editForm.outputTotalAmount.max, 'unsigned');switchObjMaxAndMin(editForm.outputTotalAmount)"
                                    v-model="editForm.outputTotalAmount.max"
                                    placeholder="请输入最大值"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="合作品牌出款排行榜">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-yongdong/009.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-yongdong/009.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       合作品牌出款 = 最小值（整数）和最大值（整数）之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.cooperationBrandOutputRank" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'cooperationBrandOutputRank.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入品牌名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">品牌名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'cooperationBrandOutputRank.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min=switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.cooperationBrandOutputRank, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'cooperationBrandOutputRank.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max=switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.cooperationBrandOutputRank, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.cooperationBrandOutputRank.length === 1}" 
                                    :title="editForm.cooperationBrandOutputRank.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('cooperationBrandOutputRank', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('cooperationBrandOutputRank', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="设计师接取的款式设计订单">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-yongdong/010.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-yongdong/010.png">
                        </div>
                    </el-popover>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.designerGetStyleOrder" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerGetStyleOrder.' + index + '.style'"
                                    :rules="[
                                        { required: true, message: '请输入款式名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.style" :disabled="uneditable">
                                        <template slot="prepend">款式名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerGetStyleOrder.' + index + '.customer'"
                                    :rules="[
                                        { required: true, message: '请输入客户名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.customer" :disabled="uneditable">
                                        <template slot="prepend">客户</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.designerGetStyleOrder.length === 1}" 
                                    :title="editForm.designerGetStyleOrder.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('designerGetStyleOrder', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('designerGetStyleOrder', index)"
                                ></i>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-top: 16px;">
                            <el-col :span="1">
                                &nbsp;
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerGetStyleOrder.' + index + '.designer'"
                                    :rules="[
                                        { required: true, message: '请输入设计师名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.designer" :disabled="uneditable">
                                        <template slot="prepend">设计师名</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerGetStyleOrder.' + index + '.progress'"
                                    :rules="[
                                        { required: true, message: '请输入进度', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.progress" :disabled="uneditable">
                                        <template slot="prepend">进度</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="设计师发出的工艺对接订单">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-yongdong/011.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-yongdong/011.png">
                        </div>
                    </el-popover>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.designerSendCraftOrder" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerSendCraftOrder.' + index + '.style'"
                                    :rules="[
                                        { required: true, message: '请输入款式名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.style" :disabled="uneditable">
                                        <template slot="prepend">款式名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerSendCraftOrder.' + index + '.classify'"
                                    :rules="[
                                        { required: true, message: '请输入分类', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.classify" :disabled="uneditable">
                                        <template slot="prepend">分类</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.designerSendCraftOrder.length === 1}" 
                                    :title="editForm.designerSendCraftOrder.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('designerSendCraftOrder', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('designerSendCraftOrder', index)"
                                ></i>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-top: 16px;">
                            <el-col :span="1">
                                &nbsp;
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerSendCraftOrder.' + index + '.designer'"
                                    :rules="[
                                        { required: true, message: '请输入设计师名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.designer" :disabled="uneditable">
                                        <template slot="prepend">设计师名</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerSendCraftOrder.' + index + '.standard'"
                                    :rules="[
                                        { required: true, message: '请输入执行标准', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.standard" :disabled="uneditable">
                                        <template slot="prepend">执行标准</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="设计师确认的制版对接订单">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-yongdong/012.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-yongdong/012.png">
                        </div>
                    </el-popover>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.designerConfirmPlatemakingOrder" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerConfirmPlatemakingOrder.' + index + '.style'"
                                    :rules="[
                                        { required: true, message: '请输入款式名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.style" :disabled="uneditable">
                                        <template slot="prepend">款式名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerConfirmPlatemakingOrder.' + index + '.classify'"
                                    :rules="[
                                        { required: true, message: '请输入分类', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.classify" :disabled="uneditable">
                                        <template slot="prepend">分类</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.designerConfirmPlatemakingOrder.length === 1}" 
                                    :title="editForm.designerConfirmPlatemakingOrder.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('designerConfirmPlatemakingOrder', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('designerConfirmPlatemakingOrder', index)"
                                ></i>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="margin-top: 16px;">
                            <el-col :span="1">
                                &nbsp;
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerConfirmPlatemakingOrder.' + index + '.designer'"
                                    :rules="[
                                        { required: true, message: '请输入设计师名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.designer" :disabled="uneditable">
                                        <template slot="prepend">设计师名</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'designerConfirmPlatemakingOrder.' + index + '.model'"
                                    :rules="[
                                        { required: true, message: '请输入版型', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.model" :disabled="uneditable">
                                        <template slot="prepend">版型</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>

                <el-form-item class="c-form-item" label="园区企业及对应产值">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-yongdong/013.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-yongdong/013.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       园区企业对应产值=在全年最小值与全年最大值之间按自然日递增
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.parkCompanyOutputValue" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'parkCompanyOutputValue.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入企业名称', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">企业名称</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'parkCompanyOutputValue.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min=switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.parkCompanyOutputValue, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'parkCompanyOutputValue.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值（正整数）', trigger: 'blur' }
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max=switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.parkCompanyOutputValue, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.parkCompanyOutputValue.length === 1}" 
                                    :title="editForm.parkCompanyOutputValue.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('parkCompanyOutputValue', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('parkCompanyOutputValue', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>
            </el-form>
            <div class="bottom-btns-wrap" v-if="!uneditable">
                <el-button class="btn-cancel" @click="cancelEdit">取消</el-button>
                <el-button class="btn-large" type="primary" @click="submitHandle">提交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {ajaxDatav} from '../../common/request_datav.js'
export default {
    data() {
        return {
            uneditable: true,
            editForm: {
                // 设计师品牌订单金额 
                designerOrderAmount: [
                    {
                        key: 1,
                        name: '', // 设计师名称
                        min: '',  // 配置最小值
                        max: ''   // 配置最大值
                    }
                ],

                // 本季服装设计关键词
                designKeyWords: [
                    {
                        key: 1,
                        name: '',   // 关键词
                        weight: '',  // 权重
                        type: '',   // 展示类别
                    }
                ],

                // 品牌出款排行
                brandOutputRank: [
                    {
                        key: 1,
                        name: '',   // 企业名称
                        radix: '',  // 出款量
                    }
                ],

                // 销售渠道占比
                salesChannelPercent: [
                    {
                        key: 1,
                        name: '', // 渠道名称
                        min: '',  // 配置最小值
                        max: ''   // 配置最大值
                    }
                ],

                // 入驻设计师数
                designerJoinNumber: {
                    radix: '', // 固定基数
                    min: '',   // 配置最小值
                    max: '',   // 配置最大值
                },

                // 对接版房
                connectSampleRoom: {
                    radix: '', // 固定基数
                    min: '',   // 配置最小值
                    max: '',   // 配置最大值
                },

                // 投产量
                productionAmount: {
                    radix: '', // 固定基数
                    min: '',   // 配置最小值
                    max: '',   // 配置最大值
                },

                // 出款总金额
                outputTotalAmount: {
                    radix: '', // 固定基数
                    min: '',   // 配置最小值
                    max: '',   // 配置最大值
                },

                // 合作品牌出款排行榜
                cooperationBrandOutputRank: [
                    {
                        key: 1,
                        name: '', // 品牌名称
                        min: '',  // 配置最小值
                        max: ''   // 配置最大值
                    }
                ],

                // 设计师接取的款式设计订单
                designerGetStyleOrder: [
                    {
                        key: 1,
                        style: '',      // 款式名称
                        designer: '',   // 设计师名
                        customer: '',   // 客户
                        progress: '',   // 进度
                    }
                ],

                // 设计师发出的工艺对接订单
                designerSendCraftOrder: [
                    {
                        key: 1,
                        style: '',    //  款式名称
                        designer: '', // 设计师名
                        classify: '', // 分类
                        standard: '' // 执行标准
                    }
                ],

                // 设计师确认的制版对接订单
                designerConfirmPlatemakingOrder: [
                    {
                        key: 1,
                        style: '',    // 款式名称
                        designer: '', // 设计师名
                        classify: '', // 分类
                        model: '',    // 版型
                    }
                ],

                // 园区企业及对应产值
                parkCompanyOutputValue: [
                    {
                        key: 1,
                        name: '', // 企业名称
                        min: '',  // 全年最小值
                        max: '',  // 全年最大值
                    }
                ]
            }
        }
    },
    created() {
        this.getData();
    },
    methods: {
        // 编辑操作
        editHandle() {
            this.uneditable = false
        },
        // 取消编辑
        cancelEdit() {
            this.$confirm('确认取消编辑吗?', '提示', {
                confirmButtonText: '取消编辑',
                cancelButtonText: '继续编辑',
                type: 'warning'
            }).then(() => {
                this.uneditable = true
                this.$refs['editForm'].clearValidate()
                this.getData();
            })
        },
        // 跳转外部链接
        linkToDataV() {
            window.open('https://datav.aliyuncs.com/share/e4de1f29b90ab040040c3c309a3e55c4')
        },
        // 立即生效
        takeEffectAtOnce() {
            this.$confirm('数据配置默认第二天零点生效，若需立即生效，可使用本功能。本功能将立即刷新数据到大屏，有可能造成当日数据前后不一致。请谨慎使用。', '提示', {
                confirmButtonText: '立即生效',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                console.log('立即生效')
                ajaxDatav.post('/data-statistics/refreshByNumber', {
                    number: 4
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success('提交成功，配置的数据会立即生效到大屏！');
                    } else {
                        this.$message.error(res.msg)
                    }
                }).catch(e => {
                    console.error(e)
                })
            }).catch(err=> {
                console.log(err)
            })
        },
        // 回到顶部
        toPageTop() {
            document.querySelector('#mainBox').scrollTop = 0;
        },
        // 删除一行
        removeLine(key, index) {
            let length = this.editForm[key].length
            if (length <= 1) return
            this.editForm[key].splice(index, 1)
        },
        // 添加一行
        addLine(key, index) {
            let d = Date.now()
            let item

             if (key == 'designKeyWords') {
                item = {
                    key: d,
                    name: '',
                    weight: '',
                    type: '', 
                }
            }
            if (key == 'brandOutputRank') {
                item = {
                    key: d,
                    name: '',
                    radix: ''
                }
            }
            if (key == 'provinceOrder') {
                item = {
                    key: d,
                    name: '',
                    rate: '',
                    radix: ''
                }
            }
            if (key == 'salesChannelPercent' || key == 'cooperationBrandOutputRank' || key == 'parkCompanyOutputValue' || key == 'designerOrderAmount') {
                item = {
                    key: d,
                    name: '',
                    min: '',
                    max: ''
                }
            }
            if (key == 'designerGetStyleOrder') {
                item = {
                    key: d,
                    style: '',      
                    designer: '',   
                    customer: '',  
                    progress: '',   
                }
            }
            if (key == 'designerSendCraftOrder') {
                item = {
                    key: d,
                    style: '',    
                    designer: '', 
                    classify: '',
                    standard: '' 
                }
            }
            if (key == 'designerConfirmPlatemakingOrder') {
                item = {
                    key: d,
                    style: '',    
                    designer: '', 
                    classify: '', 
                    model: '',    
                }
            }

            this.editForm[key].splice(index+1, 0, item)
        },
        // 转化为整数
        switchToInt(value, type) {
            let v = parseInt(value)
            if (isNaN(v)) return ''
            return type === 'unsigned' ? Math.abs(v) : v
        },
        // 转化为浮点数
        switchToFloat(value, type) {
            let v = parseFloat(value)
            if (isNaN(v)) return ''
            return type === 'unsigned' ? Math.abs(v) : v
        },
        // 获取数据
        getData() {
            ajaxDatav.get('/data-setting/getByNumber', {
                number: 4
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    if (res.data && res.data.content) {
                        try {
                            let content = JSON.parse(res.data.content);
                            this.editForm = {
                                ...this.editForm,
                                ...content
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(e => {
                console.error(e);
            })
        },
        // 提交表单
        submitHandle() {
            console.log('submit');
            // console.log(this.editForm);
            // console.log(JSON.stringify(this.editForm));

            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: '正在提交数据...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    ajaxDatav.post('/data-setting/save', {
                        content: JSON.stringify(this.editForm),
                        number: 4
                    }).then(res => {
                        if (res.code == 200) {
                            this.$message.success('提交成功');
                            this.uneditable = true
                            this.getData();
                        } else {
                            this.$message.error(res.msg)
                        }
                    }).catch(e => {
                        console.error(e)
                    }).finally(() => {
                        loading.close();
                    })
                } else {
                    this.$message.error('校验不通过，请检查表单')
                }
            })
        },
        // 自动切换对象中最大值和最小值
        switchObjMaxAndMin(obj, min='min', max='max') {
            if (obj[min] === '' || obj[max] === '') return
            if (obj[min] > obj[max]) {
                let middle = obj[min]
                obj[min] = obj[max]
                obj[max] = middle
            }
        },
        // 自动切换列表中最大值和最小值
        switchMaxAndMin(list, index, min='min', max='max') {
            if (list[index][min] === '' || list[index][max] === '') return
            if (list[index][min] > list[index][max]) {
                let middle = list[index][min]
                list[index][min] = list[index][max]
                list[index][max] = middle
            }
        }
    }
}
</script>

<style scoped lang="scss">
.page-wrapper {
    background: #fff;
    padding-bottom: 80px;
    min-height: 100px;
    .tit {
        margin: 0;
        padding: 24px;
        font-size: 20px;
        color: #111;
        font-weight: normal;
    }
    .top-btns {
        position: fixed;
        top: 40%;
        right: 32px;
        z-index: 100;
        .r-btn {
            margin-top: 6px;
        }
    } 
    .datav-form-wrapper {
        width: 900px;
        padding: 0 24px;
        .w {
            width: 400px;
        }
        .w2 {
            width: 200px;
        }
        .info {
            font-size: 13px;
            color: #888;
            line-height: 1.5;
        }
    }
    .c-row-wrap {
        padding: 8px 0;
    }
    .c-sort-num {
        margin-top: 12px;
        display: block;
        width: 20px;
        height: 20px;
        border: 1px solid #999;
        line-height: 20px;
        text-align: center;
        color: #999;
        font-size: 12px;
        border-radius: 50%;
    }
    .c-remove {
        margin-right: 4px;
        cursor: pointer;
        font-size: 16px;
        &.disabled {
            color: #ccc;
            cursor: no-drop;
        }
    }
    .c-add {
        font-size: 16px;
        cursor: pointer;
    }
    .bottom-btns-wrap {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 20px 0 20px 0px;
        text-align: center;
        z-index: 1;
        background: #fff;
        box-shadow: 0 -2px 10px #ccc;
        .btn-large {
            padding: 14px 120px;
        }
        .btn-cancel {
            padding-top: 14px;
            padding-bottom: 14px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/datav/park-yongdong.vue